import { createContext, useContext } from 'react'
import { type IResponseFullSurvey } from 'entities/Surveys/api/types'

export const SurveysIdContext = createContext<IResponseFullSurvey | null>(null)

export const useSurveysIdContext = () => {
  const context = useContext(SurveysIdContext)

  if (context === null)
    throw new Error('You have forgotten to wrap your root component with SurveysIdContext')

  return context
}
